import React from 'react'
import { PiCalendarBlank } from 'react-icons/pi'
import {
  PerformanceRange,
  PERFORMANCE_RANGE_LABELS,
} from '../../services/recommendations_api'
import { FbDropdown } from '../FbUI/FbDropdown'
import { secondaryPillHoverClass } from '../FbUI/secondaryPillButton'
import { cn } from '../UI/cn'

/** Ordered list of range options for the dropdown. */
const RANGE_OPTIONS: PerformanceRange[] = ['3m', '6m', '12m', 'ytd', 'all']

interface RangeSelectorProps {
  /** Currently selected time range. */
  value: PerformanceRange
  /** Callback fired when the user selects a different range. */
  onChange: (value: PerformanceRange) => void
  /** Optional additional CSS class names. */
  className?: string
}

/**
 * Dropdown selector for choosing a time range for performance data.
 *
 * Provides preset options (3m, 6m, 12m, YTD, All Time) that cover
 * common use cases for reviewing historical performance.
 */
export const RangeSelector: React.FC<RangeSelectorProps> = ({
  value,
  onChange,
  className,
}) => {
  const items = RANGE_OPTIONS.map((range) => ({
    key: range,
    label: PERFORMANCE_RANGE_LABELS[range],
  }))

  return (
    <FbDropdown
      label={PERFORMANCE_RANGE_LABELS[value]}
      icon={
        <PiCalendarBlank
          size={14}
          className="text-brand-active flex-shrink-0"
        />
      }
      items={items}
      selectedKey={value}
      onAction={(key) => onChange(key as PerformanceRange)}
      className={cn(secondaryPillHoverClass, className)}
      placement="bottom end"
    />
  )
}
